/**
 * Conversion between `<input type="datetime-local">` and the API's ISO instants.
 *
 * The member types a wall-clock time; the API stores an instant. `toISOString()
 * .slice(0, 16)` is UTC, so an Istanbul member entering 20:00 would post 17:00 —
 * and a deposit timestamp three hours early is still inside the window, which is
 * exactly what makes it hard to notice.
 */

/** ISO instant → what a `datetime-local` expects, built from LOCAL getters. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) {
    return '';
  }

  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const pad = (value: number) => String(value).padStart(2, '0');

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

/**
 * The input's value → an ISO instant, or null when it is empty.
 *
 * No zone suffix means LOCAL to `new Date`, which is what the member meant. The
 * caller decides what an empty field means; here it is null.
 */
export function fromLocalInput(value: string): string | null {
  if (value.trim() === '') {
    return null;
  }

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}
